import { trackGAToGSNTV, isIframed } from "./gsntv";

const TRACKING_EVENT_CATEGORY = '25daysofchristmas-sweeps';

export const track = (action, analytics) => {
  analytics &&
    window.gtag &&
    window.gtag('event', action, analytics);
};

export const trackingWrapper = (type, action, trackingObject) => {
  
  if (!isIframed()) {
    track(action, trackingObject);

  } else {
    const { event_category, event_label, value } = trackingObject;
    const data = {action, category: event_category, label: event_label, value};
    trackGAToGSNTV(data);
  }
};

export const evtTrack = (action, event_label, value) => {
  trackingWrapper('event', action, {event_category: TRACKING_EVENT_CATEGORY, event_label, value});
}